import { QUINCY_MODES } from '../../library/constants';
import { QUINCYGETTERS } from '../../store/quincy';
import {
  convertMarkerToSymptom,
  convertMarkerToSymptomPoint,
  convertSymptomPointToMarker,
  convertSymptomToMarker
} from '@common/Helpers/symptoms';
import { mapGetters, mapMutations } from 'vuex';
import core from '../../store/quincy/core';
import { CURRENT_USER_GETTERS } from '@/store/modules/currentuser';
import { MUTATIONS } from '../../store/quincy/definitions';
import { interaction } from './';
import SymptomReportService from '@common/Services/SymptomReports/SymptomReportService';
const THREE = require('three');
// const distanceBetweenBeforeNewSymptom = 1.5;

export default {
  mixins: [interaction],
  data() {
    return {
      lastPointPosition: null,
      modelLoaded: false,
      activeSymptomSaved: false,
      symptomsSubscription: null,
      symptomPointDrawn: false,
      symptomPoint: null,
      actionQueue: []
    };
  },
  mounted() {
    this.symptomsSubscription = this.$store.subscribe(mutation => {
      if (mutation.type === `quincy/${MUTATIONS.MARK_BODY}`) {
        this.markBody(mutation.payload);
      }

      if (mutation.type === `quincy/${MUTATIONS.UNMARK_BODY}`) {
        this.unmarkBody(mutation.payload);
      }

      if (mutation.type === `quincy/${MUTATIONS.MODEL_LOADED}`) {
        this.modelLoaded = true;
        this.loadMarkersFromOldReportTimer();
      }

      if (mutation.type === `quincy/${MUTATIONS.CLICK_SYMPTOM}`) {
        this.clickedSymptom(mutation.payload);
      }

      if (mutation.type === `quincy/${MUTATIONS.RESET}` || mutation.type === `quincy/${MUTATIONS.REMOVE_ENTIRE_DRAWING}`) {
        this.removeAllMarkers();
      }

      if (mutation.type === `quincy/${MUTATIONS.SET_SYMPTOMREPORT}`) {
        this.removeAllMarkers();
        this.addLoadedSymptomsToBody();
      }

      if (mutation.type === `quincy/${MUTATIONS.TOGGLE_DRAWING}`) {
        if (!mutation.payload) {
          let i = this.actionQueue.length;
          while (i--) {
            const action = this.actionQueue[0];
            action();
            if (action) {
              this.actionQueue.splice(0, 1);
            }
          }
        }
      }

      if (mutation.type === `quincy/${MUTATIONS.CANCEL_ACTION}`) {
        this.symptomPoint = null;
        this.symptomPointDrawn = false;
      }
    });
  },
  beforeUnmount() {
    this.symptomsSubscription();
  },
  watch: {
    symptomCount(newValue, oldValue) {
      if (newValue >= oldValue || (newValue > 0 && oldValue === undefined)) {
        this.loadMarkersFromOldReportTimer();
        // this.triggerRender();
        return;
      }
      this.removeDiscardedMarkers();
      // this.triggerRender('symptomCount');
    },
    activeSymptom(newValue, oldValue) {
      if (newValue === null) {
        this.lastPointPosition = null;
      }

      // new active symptom
      if (newValue) {
        this.removeNonActiveMarkers();
        this.symptomPointDrawn = true;
        this.symptomPoint = newValue;
      }

      // no active symptom
      if (!newValue && oldValue) {
        if (this.$MODE === QUINCY_MODES.SIMPLE) { return; }
        this.removeSymptomMarkers(oldValue);
        this.addLoadedSymptomsToBody();
        this.triggerRender('removeOldSymptomBalls');
        this.symptomPointDrawn = false;
        this.symptomPoint = null;
        return;
      }

      if (
        (!newValue && oldValue.isCurrent === true) ||
        (!newValue && oldValue && this.report.findSymptom(oldValue))
      ) {
        this.restoreSymptomMarkers(this.report._tempSymptom, oldValue);
        this.triggerRender('restoreSymptomMarkers');
        return;
      }

      if (newValue || oldValue._saved === true) {
        this.removeAllMarkers();
        this.addActiveSymptomToBody();
        this.triggerRender('activeSymptom');
        return;
      }

      this.removeSymptomMarkers(oldValue);
      this.triggerRender('removeSymptomMarkers');
      this.lastPointPosition = null;
    },
    'activeSymptom._saved'(newValue) {
      if (this.activeSymptom) {
        const markers = this.findSymptomMarker(this.activeSymptom.SymptomId);
        if (markers) {
          markers.forEach(marker => (marker.userData.saved = newValue));
          // this.triggerRender('activeSymptom saved');
        }
      }
    },
    'activeSymptom.Intensity'(newValue) {
      if (newValue === undefined) {
        return;
      }
      this.changeMarkerOpacity(this.activeSymptom);
      this.triggerRender('activeSymptom intensity');
    },
  },
  methods: {
    ...mapMutations('quincy', {
      $MODELLOADED: MUTATIONS.MODEL_LOADED,
      $SETACTIVESYMPTOM: MUTATIONS.SET_ACTIVE_SYMPTOM,
      $TOGGLEDRAWING: MUTATIONS.TOGGLE_DRAWING,
      $ADDSYMPTOM: MUTATIONS.ADD_SYMPTOM,
      $ADDSYMPTOMPOINT: MUTATIONS.ADD_SYMPTOM_POINT,
      $REMOVESYMPTOM: MUTATIONS.REMOVE_SYMPTOM,
      $REMOVEDRAWING: MUTATIONS.REMOVE_ENTIRE_DRAWING,
      $REMOVESYMPTOMPOINT: MUTATIONS.REMOVE_SYMPTOM_POINT
    }),
    restoreSymptomMarkers(oldSymptom, currentSymptom) {
      if (!oldSymptom || !currentSymptom) {
        return;
      }
      if (
        (oldSymptom.Intensity === currentSymptom.Intensity &&
          oldSymptom.SymptomPoints.length ===
          currentSymptom.SymptomPoints.length) ||
        this.report._lastAction === 'save'
      ) {
        // No reset needed
        return;
      }

      this.removeSymptomMarkers(oldSymptom);
      this.addMarker(convertSymptomToMarker(oldSymptom));

      oldSymptom.SymptomPoints.forEach(point => {
        this.addMarker(convertSymptomPointToMarker(point, oldSymptom));
      });

      this.changeMarkerOpacity(oldSymptom);
      this.triggerRender('restoreSymptomMarkers');
    },
    loadMarkersFromOldReportTimer() {
      if (this.modelLoaded === true && this.report) {
        if (this.$router.currentRoute.name == 'GroupSymptomsVisualizationView') {
          this.addGroupSymptomsToBody();
        }
        this.addLoadedSymptomsToBody();
      } else {
        setTimeout(() => this.loadMarkersFromOldReportTimer(), 500);
      }
    },

    addLoadedSymptomsToBody() {
      if (!this.loadBalls) { return; }

      this.report.Symptoms.forEach(symptomReportSymptom => {
        this.addMarker(convertSymptomToMarker(symptomReportSymptom));
        symptomReportSymptom.SymptomPoints.forEach(point => {
          this.addMarker(convertSymptomPointToMarker(point, symptomReportSymptom));
        });
      });
    },

    addActiveSymptomToBody() {
      if (!this.activeSymptom) {
        return;
      }

      this.addMarker(convertSymptomToMarker(this.activeSymptom));
      // this.triggerRender('addActiveSymptomToBody');
      this.activeSymptom.SymptomPoints.forEach(point => {
        this.addMarker(convertSymptomPointToMarker(point, this.activeSymptom));
        // this.triggerRender('addActiveSymptomPointToBody');
      });
    },
    addGroupSymptomsToBody() {
      this.removeAllMarkers();
      SymptomReportService.getGroupSymptomReports(this.$activeGroup.Id, this.$activeGroup.OrganizationId, this.$router.currentRoute.params.fromDate, this.$router.currentRoute.params.toDate).then(response => {
        response.forEach((symptomReport) => {
          //filtering
          if (symptomReport.Model == this.$router.currentRoute.params.model) {
            symptomReport.Symptoms.forEach((symptom) => {
              this.addMarker(convertSymptomToMarker(symptom));
              symptom.SymptomPoints.forEach(point => {
                this.addMarker(convertSymptomPointToMarker(point, symptom));
              });
            });
          }
        });


      });
    },



    clickedSymptom(data) {
      this.lastPointPosition = data.point;
    },
    markBody(data) {
      if (this.report.editable === false) {
        return;
      }

      let marker = null;

      const createNewSymptom = () => !(this.activeSymptom.PosX && this.activeSymptom.PosY && this.activeSymptom.PosZ);

      if (createNewSymptom()) {
        data.Size = this.getSizeFromZoom(data.point);
        const symptomData = convertMarkerToSymptom(data, this.$ACTIVETYPE);

        // Set ID's for symptom data in case the active symptom exists but
        // is completely fresh (i.e. first time user clicks on card to draw)
        symptomData.SymptomId = this.activeSymptom.SymptomId;
        symptomData.Symptom.Id = this.activeSymptom.SymptomId;

        symptomData.Intensity = this.activeSymptom.Intensity;

        // this.actionQueue.push(() =>
        this.$ADDSYMPTOM({
          symptom: symptomData
        });
        // );

        marker = convertSymptomToMarker(symptomData);
        this.symptomPoint = this.activeSymptom;
        this.symptomPointDrawn = true;
      } else {
        const symptomPointData = convertMarkerToSymptomPoint(data);
        symptomPointData.Size = this.getSizeFromZoom(data.point);

        this.actionQueue.push(() => this.$ADDSYMPTOMPOINT(symptomPointData));

        marker = convertSymptomPointToMarker(
          symptomPointData,
          this.symptomPoint
        );
      }

      this.lastPointPosition = data.point;
      this.addMarker(marker);
    },

    unmarkBody(data) {
      const [type, position] = data.name.split('||'); //eslint-disable-line
      const marker = this.findMarker(data.id);

      if (marker) {
        switch (type) {
          case 'Symptom': {
            this.$REMOVESYMPTOM({
              userData: marker.userData,
              position: marker.position
            });
            break;
          }
          case 'SymptomPoint': {
            this.$REMOVESYMPTOMPOINT({
              userData: marker.userData,
              position: marker.position
            });
          }
        }

        const remove = this.findMarker(marker.userData.Id);
        this.removeMarkers(remove);

        if (type === 'Symptom') {
          this.removeAllMarkers();
          setTimeout(() => this.addActiveSymptomToBody(), 0);
        }
      }
    },

    removePreviousSymptom() {
      this.removeAllUnsavedMarkers();
      this.$emit('removeActiveSymptom'); // eslint-disable-line
    },

    //eslint-disable-next-line
    addMarker(data, isNew = false, baseSize = 0.2) {
      if (!data || this.findMarker(data.Id)) {
        return;
      }
      const isSymptomArea = data => data.hasOwnProperty('parent');

      let size = data.Size !== 1 ? data.Size * baseSize : baseSize;
      let id = data.Id;
      let name = `Symptom||${data.SymptomId}`;
      let color = data.color;
      let opacity = data.opacity;
      let intensity = Number(data.Intensity);
      let symptomid = data.SymptomId;
      if (data.hasOwnProperty('color')) {
        color = data.color;
      }

      if (isSymptomArea(data)) {
        name = `SymptomPoint||${data.parent.SymptomId}`;
        intensity = data.parent.Intensity;
        symptomid = data.parent.SymptomId;
        color = data.parent._color;
        opacity = data.parent._opacity;
      }

      if (intensity === 0) {
        color = '0xCCCCCC';
        opacity = 1;
      }

      const geometry = new THREE.SphereGeometry(size, 5, 5);
      const material = new THREE.MeshBasicMaterial({
        transparent: true,
        depthTest: true,
        depthWrite: true,
        opacity: opacity
      });

      const marker = new THREE.Mesh(geometry, material);
      marker.position.copy(data.point);
      marker.name = name;
      marker.size = size;
      marker.userData.size = size;
      marker.userData.type = data.type;
      marker.userData.Id = id;
      marker.userData.saved = data.saved || false;
      marker.userData.SymptomId = symptomid;
      marker.userData.Intensity = intensity;
      marker.material.color.setHex(color);
      core.object.add(marker);
      this.lastMarker = marker;

      // this.triggerRender(`addMarker`);
    },

    findMarker(id) {
      if (core.object === undefined) {
        return false;
      }
      return core.object.children.find(child => child.userData.Id === id);
    },

    findMarkerIndex(id) {
      if (core.object === undefined) {
        return false;
      }
      return core.object.children.findIndex(child => child.userData.Id === id);
    },

    findMarkerByName(name) {
      if (core.object === undefined) {
        return false;
      }
      return core.object.children.find(child => child.name === name);
    },

    findSymptomMarker(symptomid) {
      if (core.object === undefined) {
        return false;
      }
      return core.object.children.filter(
        child => child.userData.SymptomId === symptomid
      );
    },

    changeMarkerColor(symptom) {
      symptom = convertSymptomToMarker(symptom);
      this.findSymptomMarker(symptom.SymptomId).forEach(marker => {
        marker.userData.Intensity = symptom.Intensity;
        marker.material.color.setHex(symptom.Color);
      });
    },

    changeMarkerOpacity(symptomReportSymptom) {
      this.findSymptomMarker(symptomReportSymptom.SymptomId).forEach(marker => {
        marker.userData.Intensity = symptomReportSymptom.Intensity;
        marker.material.opacity = symptomReportSymptom._opacity;

        if (symptomReportSymptom.Intensity === 0) {
          marker.material.color.setHex('0xCCCCCC');
          marker.material.opacity = 1;
        } else {
          marker.material.color.setHex(symptomReportSymptom._color);
        }
      });
    },

    removeNonActiveMarkers() {
      const markers = this.getAllMarkers();

      if (this.activeSymptom) {
        const activeSymptomId = this.activeSymptom.SymptomId;

        markers.forEach(marker => {
          if (marker.userData.SymptomId !== activeSymptomId) {
            core.object.remove(marker);
          }
        });
      } else {
        this.removeAllMarkers();
      }
    },

    removeSymptomMarkers(symptom) {
      this.findSymptomMarker(symptom.SymptomId).forEach(marker => {
        core.object.remove(marker);
      });
    },

    removeDiscardedMarkers() {
      if (core.object === null || this.report === undefined) {
        return;
      }
      const markers = this.getAllMarkers();
      markers.forEach(child => {
        if (
          !this.report.Symptoms.find(s => s.SymptomId === child.userData.SymptomId)
        ) {
          core.object.remove(child);
        }
      });
    },

    removeAllMarkers(onlyUnsaved) {
      if (core.object === null) {
        return;
      }
      const markers = this.getAllMarkers();

      markers.forEach(child => {
        if (onlyUnsaved && child.userData.saved === true) {
          return;
        }
        core.object.remove(child);
        // this.triggerRender();
      });
    },

    removeMarkers(markersToRemove) {
      if (markersToRemove instanceof Object) {
        markersToRemove = [markersToRemove];
      }

      markersToRemove = markersToRemove.map(m => m.userData.Id);
      core.object.children.forEach(child => {
        if (markersToRemove.indexOf(child.userData.Id) > -1) {
          core.object.remove(child);
        }
        // this.triggerRender();
      });
    },

    removeAllUnsavedMarkers() {
      this.removeAllMarkers(true);
    },

    getAllMarkers() {
      return core.object.children.filter(marker =>
        marker.name.match(/Symptom/)
      );
    },

    getDistance(pos1, pos2) {
      pos1 = pos1 || { x: 0, y: 0 };
      var dx = pos1.x - pos2.x;
      var dy = pos1.y - pos2.y;
      var dz = pos1.z - pos2.z;
      return Math.sqrt(dx * dx + dy * dy + dz * dz);
    },

    getDistanceFromCamera(point) {
      return Math.ceil(this.getDistance(core.camera.position, point) / 5) * 5;
    },

    getSizeFromZoom(point) {
      const zoom = this.getDistanceFromCamera(point);
      const size = zoom / 30;
      if (size < 0.1) {
        return 0.1;
      } else if (size > 4.8) {
        return 4.8;
      } else {
        return parseFloat(size.toFixed(2));
      }
    },
    symptomPointCount(symptom) {
      if (!symptom) {
        return;
      }
      return symptom.SymptomPoints.length;
    }
  },
  computed: {
    ...mapGetters('quincy', {
      $MODE: QUINCYGETTERS.MODE
    }),
    ...mapGetters('currentuser', {
      $activeGroup: CURRENT_USER_GETTERS.ACTIVE_GROUP
    }),
    symptomCount() {
      if (!this.report) {
        return;
      }
      return this.report.Symptoms.length;
    }
  }
};
